/**
 * HTML画面遷移用
 */
class Redirecter {
  /**
   * 別画面（xxx.html）へ遷移させます
   * @param targfet   対象URL
   * @param blank     true:別タブ、falase:リダイレクト
   */
  openSite(targfet: string, blank: boolean) {
    if (blank) {
      window.open(targfet, '_blank', 'noopener noreferrer')
    } else {
      window.location.assign(targfet)
    }
  }
}
export const $Redirecter = new Redirecter()
